var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44917_7042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.999 23.166C21.7519 23.166 23.1728 21.745 23.1728 19.9922C23.1728 18.2393 21.7519 16.8184 19.999 16.8184C18.2462 16.8184 16.8252 18.2393 16.8252 19.9922C16.8252 21.745 18.2462 23.166 19.999 23.166Z",
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.4991C29.4055 26.4991 37.0302 23.5878 37.0302 19.9966C37.0302 16.4054 29.4055 13.4941 20 13.4941C10.5944 13.4941 2.96973 16.4054 2.96973 19.9966C2.96973 23.5878 10.5944 26.4991 20 26.4991Z",
    stroke: "#61DAFB",
    strokeWidth: 1.5482
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3687 23.2467C19.0715 31.3921 25.4051 36.5397 28.5152 34.7441C31.6252 32.9485 30.3341 24.8897 25.6313 16.7442C20.9286 8.59879 14.595 3.45123 11.4849 5.24683C8.37484 7.04244 9.66598 15.1012 14.3687 23.2467Z",
    stroke: "#61DAFB",
    strokeWidth: 1.5482
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3698 16.7447C9.66698 24.8901 8.37585 32.9489 11.4859 34.7445C14.596 36.5402 20.9296 31.3926 25.6323 23.2472C30.3351 15.1017 31.6262 7.04291 28.5162 5.24731C25.4061 3.4517 19.0725 8.59926 14.3698 16.7447Z",
    stroke: "#61DAFB",
    strokeWidth: 1.5482
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44917_7042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.7b522aa077f568eb54ab219428208606.svg";
export { ForwardRef as ReactComponent };